<div class="pt-4">
  <app-rectangle-simmer *ngIf="shimmerStatus"></app-rectangle-simmer>
</div>
<section
  class="multi-slider pt-4"
  *ngIf="recommendedData?.length > 0 && !shimmerStatus"
>
  <div>
    <div class="section-head" (mouseenter)="playOff()">
      <h2 class="mr-2">
        {{ "HOME.RECOMMENDED_FOR_YOU" | translate }}
      </h2>
      <a
        *ngIf="recommendedData?.length > 7"
        href="javascript:void(0)"
        class="text-primary view-all-link"
        routerLink="/recommended-list"
      >
        {{ "HOME.VIEW_ALL" | translate }}
      </a>
    </div>
    <div id="slider-top">
      <owl-carousel-o [options]="recommended">
        <ng-container
          *ngFor="let recommended of recommendedData; let i = index"
        >
          <ng-template carouselSlide [id]="recommended.public_id">
            <div class="series-box">
              <app-grid [data]="recommended" [gridType]="'portrait'"></app-grid>
            </div>
          </ng-template>
        </ng-container>
      </owl-carousel-o>
    </div>
  </div>
</section>
